"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SnackBar = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

require("./snackBar.sass");

var SNACK_TIMEOUT = 5000;

var SnackBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SnackBar, _Component);

  function SnackBar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SnackBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SnackBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDismiss", function () {
      var _this$props = _this.props,
          snack = _this$props.snack,
          hide = _this$props.hide;
      hide(snack.id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleAction", function () {
      var _this$props2 = _this.props,
          snack = _this$props2.snack,
          dispatch = _this$props2.dispatch;
      snack.action && dispatch(snack.action);

      _this.handleDismiss();
    });
    return _this;
  }

  (0, _createClass2.default)(SnackBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.iId = setTimeout(this.handleDismiss, SNACK_TIMEOUT);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.iId) {
        clearTimeout(this.iId);
        this.iId = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$snack = this.props.snack,
          text = _this$props$snack.text,
          actionLabel = _this$props$snack.actionLabel;
      return _react.default.createElement("div", {
        className: "snackBar"
      }, _react.default.createElement("div", {
        className: "snackBar-text"
      }, text), actionLabel && _react.default.createElement(_Button.default, {
        borderless: true,
        onClick: this.handleAction,
        label: actionLabel
      }));
    }
  }]);
  return SnackBar;
}(_react.Component);

exports.SnackBar = SnackBar;
SnackBar.propTypes = process.env.NODE_ENV !== "production" ? {
  snack: _propTypes.default.shape({
    id: _propTypes.default.any.isRequired,
    text: _propTypes.default.node.isRequired,
    actionLabel: _propTypes.default.string,
    action: _propTypes.default.object
  }).isRequired,
  dispatch: _propTypes.default.func.isRequired,
  hide: _propTypes.default.func.isRequired
} : {};

var Snacks = function Snacks(_ref) {
  var snacks = _ref.snacks,
      hide = _ref.hide,
      dispatch = _ref.dispatch;

  if (!snacks || !snacks.length) {
    return null;
  } // show first snack


  var snack = snacks[0];
  return _react.default.createElement(SnackBar, {
    key: snack.id,
    snack: snack,
    dispatch: dispatch,
    hide: hide
  });
};

var _default = Snacks;
exports.default = _default;